// Generated by TsRpcGenerator, do not modify manually
// @ts-nocheck
// noinspection JSUnusedGlobalSymbols, ES6UnusedImports

import { Observable } from "rxjs"
import { InitializedChannel } from "../api-types.ts"
import type { AppDate, AppDateTime, Nominal, Pair, Ref } from "../api-types.ts"
import { getInitial, getResult, getUpdates } from "../types.ts"

import { ApiService } from "../ApiService.ts"

import { AiAgentTask, AiAgentTaskContextItem, AiAgentTaskDetails, AiAgentTaskDomElementIn, AiAgentTaskSettings, AiAgentTaskUpdatedEvent, Batch, BatchInfo, BranchInfo, ChatBenchCase, DevTaskStats, FigmaStatus, GitHubPrInfo, GitHubStatus, GrazieLLMProfileDTO, GrazieLLMRequest, LLMLogEntry, LLMLogPage, LlmQuota, MessagesSorting, ProjectKey, TID, UAddressReviewCommentWithAiResult, UAiAgentTaskEvent, UPrCreationResult, UTaskCheckpointCheckoutResult, WarmupInfo } from "./TypeDefinitions.ts"

export interface AiAgentSpaceApi {
  addToChatBench(benchCase: ChatBenchCase): Promise<string>

  addressReviewComment(mergeRequestId: TID, discussion: TID): Promise<UAddressReviewCommentWithAiResult>

  allTaskUpdatesInRepository(projectKey: ProjectKey, repository: string): Promise<Observable<AiAgentTaskUpdatedEvent>>

  cancelTaskProcess(taskId: TID): Promise<void>

  checkoutTaskCheckpoint(taskId: TID, commitId: string, force: boolean): Promise<UTaskCheckpointCheckoutResult>

  continueTaskProcess(taskId: TID, messageId: TID): Promise<void>

  createGenericTask(projectKey: ProjectKey, repository: string, taskDescription: string, initialBranchInfo: BranchInfo | null, settings: AiAgentTaskSettings | null, items: AiAgentTaskContextItem[] | null, attachments: TID[] | null, domElements: AiAgentTaskDomElementIn[] | null, tag: string | null): Promise<TID>

  createPullRequest(taskId: string, branchName: string, title: string, description: string, shortSummary: string | null): Promise<UPrCreationResult>

  deleteTask(taskId: TID): Promise<void>

  deleteVerificationEnvironment(taskId: TID): Promise<void>

  disconnectFigmaAccount(): Promise<void>

  fileEmbeddingsAvailable(projectKey: ProjectKey, repository: string): Promise<boolean>

  getBranchInfo(projectKey: ProjectKey, repository: string, branch: string): Promise<BranchInfo>

  getDevTaskStats(taskId: TID): Promise<InitializedChannel<DevTaskStats, DevTaskStats>>

  getGitHubConfigurationUrl(projectKey: ProjectKey, repository: string): Promise<string>

  getGitHubStatus(projectKey: ProjectKey, repository: string): Promise<InitializedChannel<GitHubStatus, GitHubStatus>>

  getLlmProfileIds(): Promise<GrazieLLMProfileDTO[]>

  getOrgQuota(): Promise<LlmQuota>

  getPrShortSummary(taskId: string): Promise<string | null>

  getWarmupInfo(projectKey: ProjectKey, repository: string): Promise<WarmupInfo>

  installRemoteMCP(name: string, mcpServerUrl: string, backUrl: string): Promise<string>

  listPreviewSetupTasks(projectKey: ProjectKey, repository: string, batchInfo: BatchInfo): Promise<Batch<AiAgentTask>>

  listTasks(projectKey: ProjectKey, repository: string, principalId: TID | null, tag: string | null, successful: boolean | null, withCollaborators: boolean | null, batchInfo: BatchInfo): Promise<Batch<AiAgentTask>>

  listTasksForUser(userId: TID, successful: boolean | null, batchInfo: BatchInfo): Promise<Batch<AiAgentTask>>

  liveUpdateDebugEvents(): Promise<Observable<AppDateTime>>

  llmLog(taskId: TID, pageId: TID | null, batchInfo: BatchInfo, sorting: MessagesSorting, isContext: boolean | null): Promise<Batch<LLMLogEntry>>

  llmLogPageUpdates(taskId: TID): Promise<Observable<LLMLogPage>>

  llmLogPages(taskId: TID, batchInfo: BatchInfo, sorting: MessagesSorting, messageId: TID | null): Promise<Batch<LLMLogPage>>

  llmLogRequestContext(logEntryId: TID): Promise<GrazieLLMRequest>

  llmLogUpdates(taskId: TID, pageId: TID | null): Promise<Observable<LLMLogEntry>>

  markAsSuccessful(taskId: TID, commitId: TID | null, successful: boolean): Promise<void>

  provideConsoleLogToolResponse(taskId: TID, toolRequestId: string, log: string, url: string): Promise<void>

  provideScreenshotToolResponse(taskId: TID, toolRequestId: string, attachmentId: TID, url: string): Promise<void>

  recreatePreview(taskId: TID): Promise<void>

  reportCreatePullRequestClickedEvent(taskId: TID): Promise<void>

  reportTaskDraftGeneratedEvent(taskId: TID): Promise<void>

  restartPreview(taskId: TID): Promise<void>

  retryTaskProcess(taskId: TID, messageId: TID): Promise<void>

  startFigmaOAuthFlow(backUrl: string): Promise<string | null>

  startGitHubOAuthFlow(backUrl: string): Promise<string>

  subscribeToFigmaAuthStatus(): Promise<InitializedChannel<FigmaStatus, FigmaStatus>>

  subscribeToOpenedPullRequests(taskIds: string[]): Promise<InitializedChannel<Pair<TID, GitHubPrInfo[]>[], Pair<TID, GitHubPrInfo[]>[]>>

  task(id: TID): Promise<AiAgentTask>

  taskDetails(id: TID): Promise<AiAgentTaskDetails>

  updateTaskSettings(taskId: TID, settings: AiAgentTaskSettings): Promise<void>

  updateTaskTitle(taskId: TID, title: string): Promise<void>

  updates(taskId: TID): Promise<Observable<UAiAgentTaskEvent>>
}

export class AiAgentSpaceApiClient implements AiAgentSpaceApi {
  constructor(private service: ApiService) {}

  async addToChatBench(benchCase: ChatBenchCase): Promise<string> {
    return getResult(await this.service.rpc<string, never>("AiAgentSpaceApi/addToChatBench", {
      benchCase: benchCase,
    }))
  }

  async addressReviewComment(mergeRequestId: TID, discussion: TID): Promise<UAddressReviewCommentWithAiResult> {
    return getResult(await this.service.rpc<UAddressReviewCommentWithAiResult, never>("AiAgentSpaceApi/addressReviewComment", {
      mergeRequestId: mergeRequestId,
      discussion: discussion,
    }))
  }

  async allTaskUpdatesInRepository(projectKey: ProjectKey, repository: string): Promise<Observable<AiAgentTaskUpdatedEvent>> {
    return getUpdates(await this.service.rpc<void, AiAgentTaskUpdatedEvent>("flux/AiAgentSpaceApi/allTaskUpdatesInRepository", {
      projectKey: projectKey,
      repository: repository,
    }))
  }

  async cancelTaskProcess(taskId: TID): Promise<void> {
    return getResult(await this.service.rpc<void, never>("AiAgentSpaceApi/cancelTaskProcess", {
      taskId: taskId,
    }))
  }

  async checkoutTaskCheckpoint(taskId: TID, commitId: string, force: boolean): Promise<UTaskCheckpointCheckoutResult> {
    return getResult(await this.service.rpc<UTaskCheckpointCheckoutResult, never>("AiAgentSpaceApi/checkoutTaskCheckpoint", {
      taskId: taskId,
      commitId: commitId,
      force: force,
    }))
  }

  async continueTaskProcess(taskId: TID, messageId: TID): Promise<void> {
    return getResult(await this.service.rpc<void, never>("AiAgentSpaceApi/continueTaskProcess", {
      taskId: taskId,
      messageId: messageId,
    }))
  }

  async createGenericTask(projectKey: ProjectKey, repository: string, taskDescription: string, initialBranchInfo: BranchInfo | null, settings: AiAgentTaskSettings | null, items: AiAgentTaskContextItem[] | null, attachments: TID[] | null, domElements: AiAgentTaskDomElementIn[] | null, tag: string | null): Promise<TID> {
    return getResult(await this.service.rpc<TID, never>("AiAgentSpaceApi/createGenericTask", {
      projectKey: projectKey,
      repository: repository,
      taskDescription: taskDescription,
      initialBranchInfo: initialBranchInfo,
      settings: settings,
      items: items,
      attachments: attachments,
      domElements: domElements,
      tag: tag,
    }))
  }

  async createPullRequest(taskId: string, branchName: string, title: string, description: string, shortSummary: string | null): Promise<UPrCreationResult> {
    return getResult(await this.service.rpc<UPrCreationResult, never>("AiAgentSpaceApi/createPullRequest", {
      taskId: taskId,
      branchName: branchName,
      title: title,
      description: description,
      shortSummary: shortSummary,
    }))
  }

  async deleteTask(taskId: TID): Promise<void> {
    return getResult(await this.service.rpc<void, never>("AiAgentSpaceApi/deleteTask", {
      taskId: taskId,
    }))
  }

  async deleteVerificationEnvironment(taskId: TID): Promise<void> {
    return getResult(await this.service.rpc<void, never>("AiAgentSpaceApi/deleteVerificationEnvironment", {
      taskId: taskId,
    }))
  }

  async disconnectFigmaAccount(): Promise<void> {
    return getResult(await this.service.rpc<void, never>("AiAgentSpaceApi/disconnectFigmaAccount", {
    }))
  }

  async fileEmbeddingsAvailable(projectKey: ProjectKey, repository: string): Promise<boolean> {
    return getResult(await this.service.rpc<boolean, never>("AiAgentSpaceApi/fileEmbeddingsAvailable", {
      projectKey: projectKey,
      repository: repository,
    }))
  }

  async getBranchInfo(projectKey: ProjectKey, repository: string, branch: string): Promise<BranchInfo> {
    return getResult(await this.service.rpc<BranchInfo, never>("AiAgentSpaceApi/getBranchInfo", {
      projectKey: projectKey,
      repository: repository,
      branch: branch,
    }))
  }

  async getDevTaskStats(taskId: TID): Promise<InitializedChannel<DevTaskStats, DevTaskStats>> {
    return getInitial(await this.service.rpc<DevTaskStats, DevTaskStats>("flux/AiAgentSpaceApi/getDevTaskStats", {
      taskId: taskId,
    }))
  }

  async getGitHubConfigurationUrl(projectKey: ProjectKey, repository: string): Promise<string> {
    return getResult(await this.service.rpc<string, never>("AiAgentSpaceApi/getGitHubConfigurationUrl", {
      projectKey: projectKey,
      repository: repository,
    }))
  }

  async getGitHubStatus(projectKey: ProjectKey, repository: string): Promise<InitializedChannel<GitHubStatus, GitHubStatus>> {
    return getInitial(await this.service.rpc<GitHubStatus, GitHubStatus>("flux/AiAgentSpaceApi/getGitHubStatus", {
      projectKey: projectKey,
      repository: repository,
    }))
  }

  async getLlmProfileIds(): Promise<GrazieLLMProfileDTO[]> {
    return getResult(await this.service.rpc<GrazieLLMProfileDTO[], never>("AiAgentSpaceApi/getLlmProfileIds", {
    }))
  }

  async getOrgQuota(): Promise<LlmQuota> {
    return getResult(await this.service.rpc<LlmQuota, never>("AiAgentSpaceApi/getOrgQuota", {
    }))
  }

  async getPrShortSummary(taskId: string): Promise<string | null> {
    return getResult(await this.service.rpc<string | null, never>("AiAgentSpaceApi/getPrShortSummary", {
      taskId: taskId,
    }))
  }

  async getWarmupInfo(projectKey: ProjectKey, repository: string): Promise<WarmupInfo> {
    return getResult(await this.service.rpc<WarmupInfo, never>("AiAgentSpaceApi/getWarmupInfo", {
      projectKey: projectKey,
      repository: repository,
    }))
  }

  async installRemoteMCP(name: string, mcpServerUrl: string, backUrl: string): Promise<string> {
    return getResult(await this.service.rpc<string, never>("AiAgentSpaceApi/installRemoteMCP", {
      name: name,
      mcpServerUrl: mcpServerUrl,
      backUrl: backUrl,
    }))
  }

  async listPreviewSetupTasks(projectKey: ProjectKey, repository: string, batchInfo: BatchInfo): Promise<Batch<AiAgentTask>> {
    return getResult(await this.service.rpc<Batch<AiAgentTask>, never>("AiAgentSpaceApi/listPreviewSetupTasks", {
      projectKey: projectKey,
      repository: repository,
      batchInfo: batchInfo,
    }))
  }

  async listTasks(projectKey: ProjectKey, repository: string, principalId: TID | null, tag: string | null, successful: boolean | null, withCollaborators: boolean | null, batchInfo: BatchInfo): Promise<Batch<AiAgentTask>> {
    return getResult(await this.service.rpc<Batch<AiAgentTask>, never>("AiAgentSpaceApi/listTasks", {
      projectKey: projectKey,
      repository: repository,
      principalId: principalId,
      tag: tag,
      successful: successful,
      withCollaborators: withCollaborators,
      batchInfo: batchInfo,
    }))
  }

  async listTasksForUser(userId: TID, successful: boolean | null, batchInfo: BatchInfo): Promise<Batch<AiAgentTask>> {
    return getResult(await this.service.rpc<Batch<AiAgentTask>, never>("AiAgentSpaceApi/listTasksForUser", {
      userId: userId,
      successful: successful,
      batchInfo: batchInfo,
    }))
  }

  async liveUpdateDebugEvents(): Promise<Observable<AppDateTime>> {
    return getUpdates(await this.service.rpc<void, AppDateTime>("flux/AiAgentSpaceApi/liveUpdateDebugEvents", {
    }))
  }

  async llmLog(taskId: TID, pageId: TID | null, batchInfo: BatchInfo, sorting: MessagesSorting, isContext: boolean | null): Promise<Batch<LLMLogEntry>> {
    return getResult(await this.service.rpc<Batch<LLMLogEntry>, never>("AiAgentSpaceApi/llmLog", {
      taskId: taskId,
      pageId: pageId,
      batchInfo: batchInfo,
      sorting: sorting,
      isContext: isContext,
    }))
  }

  async llmLogPageUpdates(taskId: TID): Promise<Observable<LLMLogPage>> {
    return getUpdates(await this.service.rpc<void, LLMLogPage>("flux/AiAgentSpaceApi/llmLogPageUpdates", {
      taskId: taskId,
    }))
  }

  async llmLogPages(taskId: TID, batchInfo: BatchInfo, sorting: MessagesSorting, messageId: TID | null): Promise<Batch<LLMLogPage>> {
    return getResult(await this.service.rpc<Batch<LLMLogPage>, never>("AiAgentSpaceApi/llmLogPages", {
      taskId: taskId,
      batchInfo: batchInfo,
      sorting: sorting,
      messageId: messageId,
    }))
  }

  async llmLogRequestContext(logEntryId: TID): Promise<GrazieLLMRequest> {
    return getResult(await this.service.rpc<GrazieLLMRequest, never>("AiAgentSpaceApi/llmLogRequestContext", {
      logEntryId: logEntryId,
    }))
  }

  async llmLogUpdates(taskId: TID, pageId: TID | null): Promise<Observable<LLMLogEntry>> {
    return getUpdates(await this.service.rpc<void, LLMLogEntry>("flux/AiAgentSpaceApi/llmLogUpdates", {
      taskId: taskId,
      pageId: pageId,
    }))
  }

  async markAsSuccessful(taskId: TID, commitId: TID | null, successful: boolean): Promise<void> {
    return getResult(await this.service.rpc<void, never>("AiAgentSpaceApi/markAsSuccessful", {
      taskId: taskId,
      commitId: commitId,
      successful: successful,
    }))
  }

  async provideConsoleLogToolResponse(taskId: TID, toolRequestId: string, log: string, url: string): Promise<void> {
    return getResult(await this.service.rpc<void, never>("AiAgentSpaceApi/provideConsoleLogToolResponse", {
      taskId: taskId,
      toolRequestId: toolRequestId,
      log: log,
      url: url,
    }))
  }

  async provideScreenshotToolResponse(taskId: TID, toolRequestId: string, attachmentId: TID, url: string): Promise<void> {
    return getResult(await this.service.rpc<void, never>("AiAgentSpaceApi/provideScreenshotToolResponse", {
      taskId: taskId,
      toolRequestId: toolRequestId,
      attachmentId: attachmentId,
      url: url,
    }))
  }

  async recreatePreview(taskId: TID): Promise<void> {
    return getResult(await this.service.rpc<void, never>("AiAgentSpaceApi/recreatePreview", {
      taskId: taskId,
    }))
  }

  async reportCreatePullRequestClickedEvent(taskId: TID): Promise<void> {
    return getResult(await this.service.rpc<void, never>("AiAgentSpaceApi/reportCreatePullRequestClickedEvent", {
      taskId: taskId,
    }))
  }

  async reportTaskDraftGeneratedEvent(taskId: TID): Promise<void> {
    return getResult(await this.service.rpc<void, never>("AiAgentSpaceApi/reportTaskDraftGeneratedEvent", {
      taskId: taskId,
    }))
  }

  async restartPreview(taskId: TID): Promise<void> {
    return getResult(await this.service.rpc<void, never>("AiAgentSpaceApi/restartPreview", {
      taskId: taskId,
    }))
  }

  async retryTaskProcess(taskId: TID, messageId: TID): Promise<void> {
    return getResult(await this.service.rpc<void, never>("AiAgentSpaceApi/retryTaskProcess", {
      taskId: taskId,
      messageId: messageId,
    }))
  }

  async startFigmaOAuthFlow(backUrl: string): Promise<string | null> {
    return getResult(await this.service.rpc<string | null, never>("AiAgentSpaceApi/startFigmaOAuthFlow", {
      backUrl: backUrl,
    }))
  }

  async startGitHubOAuthFlow(backUrl: string): Promise<string> {
    return getResult(await this.service.rpc<string, never>("AiAgentSpaceApi/startGitHubOAuthFlow", {
      backUrl: backUrl,
    }))
  }

  async subscribeToFigmaAuthStatus(): Promise<InitializedChannel<FigmaStatus, FigmaStatus>> {
    return getInitial(await this.service.rpc<FigmaStatus, FigmaStatus>("flux/AiAgentSpaceApi/subscribeToFigmaAuthStatus", {
    }))
  }

  async subscribeToOpenedPullRequests(taskIds: string[]): Promise<InitializedChannel<Pair<TID, GitHubPrInfo[]>[], Pair<TID, GitHubPrInfo[]>[]>> {
    return getInitial(await this.service.rpc<Pair<TID, GitHubPrInfo[]>[], Pair<TID, GitHubPrInfo[]>[]>("flux/AiAgentSpaceApi/subscribeToOpenedPullRequests", {
      taskIds: taskIds,
    }))
  }

  async task(id: TID): Promise<AiAgentTask> {
    return getResult(await this.service.rpc<AiAgentTask, never>("AiAgentSpaceApi/task", {
      id: id,
    }))
  }

  async taskDetails(id: TID): Promise<AiAgentTaskDetails> {
    return getResult(await this.service.rpc<AiAgentTaskDetails, never>("AiAgentSpaceApi/taskDetails", {
      id: id,
    }))
  }

  async updateTaskSettings(taskId: TID, settings: AiAgentTaskSettings): Promise<void> {
    return getResult(await this.service.rpc<void, never>("AiAgentSpaceApi/updateTaskSettings", {
      taskId: taskId,
      settings: settings,
    }))
  }

  async updateTaskTitle(taskId: TID, title: string): Promise<void> {
    return getResult(await this.service.rpc<void, never>("AiAgentSpaceApi/updateTaskTitle", {
      taskId: taskId,
      title: title,
    }))
  }

  async updates(taskId: TID): Promise<Observable<UAiAgentTaskEvent>> {
    return getUpdates(await this.service.rpc<void, UAiAgentTaskEvent>("flux/AiAgentSpaceApi/updates", {
      taskId: taskId,
    }))
  }

}

